/*=========================================================================================
  File Name: module-misaorder.js
  Description: misaorder Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-misaorder-state';
import mutations from './module-misaorder-mutations';
import actions from './module-misaorder-actions';
import getters from './module-misaorder-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
